import styled from 'react-emotion';

export default styled.h2`
	border-bottom: 1px solid #d9d9d9;
	color: #595959;
	font-size: 0.75rem;
	font-weight: 300;
	line-height: 1.75;
	margin: 0 0 0.5rem 0;
	text-transform: uppercase;

	aside & {
		border-bottom: none;
	}
`;
